import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import React from "react";

 interface GetActiveStatusIconProps {
   status: boolean | null | undefined;
 }

const GetActiveStatusIcon: React.FC<GetActiveStatusIconProps> = ({
  status
}) => {
  if (status) {
    return <CheckOutlined style={{ color: "var(--tertiary-color)" }} />;
  } else if (status === false) {
    return <CloseOutlined style={{ color: "var(--red)" }} />;
  } else {
    return <></>;
  }
};
export default GetActiveStatusIcon;